import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Sitemap = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sitemapLinks = [
    {
      category: 'Main Pages',
      links: [
        { name: 'Home', path: '/' },
        { name: 'Privacy Policy', path: '/privacy' },
        { name: 'Terms of Service', path: '/terms' },
        { name: 'SMS Opt-In', path: '/sms-optin' },
        { name: 'Sitemap', path: '/sitemap' },
      ]
    },
    {
      category: 'Sections',
      links: [
        { name: 'Services', path: '/', state: { scrollTo: 'services' } },
        { name: 'Why Choose Us', path: '/', state: { scrollTo: 'why-us' } },
        { name: 'Our Team', path: '/', state: { scrollTo: 'team' } },
        { name: 'How It Works', path: '/', state: { scrollTo: 'process' } },
        { name: 'Contact', path: '/', state: { scrollTo: 'contact' } },
      ]
    },
    {
      category: 'External Network',
      links: [
        { name: 'Sommers Marketing Group', url: 'https://sommersmarketinggroup.com' },
        { name: 'Dapper Dev LLC', url: 'https://dapperdev.com' },
        { name: 'After Hours CallBot', url: 'https://afterhourscallbot.com' },
      ]
    }
  ];

  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Site Map - LAJ Digital",
    "url": "https://lajdigital.com/sitemap"
  };

  return (
    <section className="pt-32 pb-24 relative bg-gray-950 min-h-screen">
      <Helmet>
        <title>Sitemap | LAJ Digital</title>
        <meta name="description" content="Navigate through LAJ Digital's content and resources using our sitemap." />
        <link rel="canonical" href="https://lajdigital.com/sitemap" />
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>

      <div className="container-custom max-w-4xl relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="glass-panel p-8 md:p-12 rounded-3xl text-gray-300 font-light space-y-8"
        >
          <div className="border-b border-gray-800 pb-8 mb-8">
            <h1 className="text-3xl md:text-4xl font-display font-bold text-white mb-4">Sitemap</h1>
            <p className="text-gray-400 text-lg">Navigate through LAJ Digital's content and resources.</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12">
            {sitemapLinks.map((section, idx) => (
              <div key={idx} className="space-y-6">
                <h2 className="text-2xl font-display font-bold text-white border-b border-gray-800 pb-2">{section.category}</h2>
                <ul className="space-y-4">
                  {section.links.map((link, linkIdx) => (
                    <li key={linkIdx}>
                      {link.url ? (
                        <a 
                          href={link.url} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="text-lg hover:text-cyan-400 transition-colors flex items-center gap-2"
                        >
                          {link.name} <span className="text-gray-600 text-sm">↗</span>
                        </a>
                      ) : (
                        <Link 
                          to={link.path}
                          state={link.state}
                          className="text-lg hover:text-cyan-400 transition-colors"
                        >
                          {link.name}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Sitemap;